import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../services/api/client.js';
import { Icons as I } from '../pack-icons';

// The metrics refresh endpoint first reconciles existing TikTok publish receipts.
// This never starts a new publish attempt, including when metrics are unavailable.
export default function TikTokStatusCheck({ postId, onReload }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [unavailable, setUnavailable] = useState(false);
  const pending = useRef(false);
  const alive = useRef(true);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);

  const check = async () => {
    if (pending.current) return;
    const scope = api.getReadScope();
    const owner = api.getReadOwnerScope();
    const current = () => alive.current && scope === api.getReadScope() && owner === api.getReadOwnerScope();
    pending.current = true;
    setBusy(true);
    setUnavailable(false);
    let failed = false;
    try {
      await api.content.refreshMetrics(postId, { limit: 5, intent: 'interactive' });
    } catch { failed = true; }
    // A partial/failed metrics response can still reconcile the publish target.
    if (current()) {
      try { await onReload(); } catch { failed = true; }
    }
    if (alive.current) {
      if (current()) setUnavailable(failed);
      setBusy(false);
    }
    pending.current = false;
  };

  return <>
    <button type="button" className="btn btn-ghost btn-sm" disabled={busy} onClick={check}>
      <I.refresh size={12} /> {t(busy ? 'postPreview.checkingStatus' : 'postPreview.checkStatus', { defaultValue: busy ? 'Checking status…' : 'Check status' })}
    </button>
    {unavailable && <span role="status" className="metric-feedback">{t('postPreview.checkStatusUnavailable', { defaultValue: 'Could not confirm the latest TikTok status. Check TikTok before posting again.' })}</span>}
  </>;
}
